import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { scoutLogin } from "../../actions/surveyActions";
import Loader from "../Loader/loader";

const InputCode = () => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  // Get phoneNumber from localStorage (saved during scoutAuth)
  const scoutAuthData = JSON.parse(localStorage.getItem("scoutAuthData"));
  const phoneNumber = scoutAuthData?.phoneNumber;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    dispatch(scoutLogin({ phoneNumber, otp }))
      .unwrap()
      .then((payload) => {
        const { token, tokenExpiresAt, scout } = payload?.data?.data;

        // Save token and scout data to localStorage
        localStorage.setItem("authToken", token);
        localStorage.setItem("tokenExpiresAt", tokenExpiresAt);
        localStorage.setItem("userDetails", JSON.stringify(scout));

        // Route based on isNewScout
        if (scout?.isNewScout === true) {
          history.push("/onboarding/name");
        } else {
          history.push("/dashboard");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.message || "Invalid OTP. Please try again.", {
          autoClose: 5000,
        });
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="section-in-base background-color-3">
        <div className="container-480">
          <div className="flex-justify-center">
            <Link to="/home" className="w-inline-block">
              <img
                src="https://assets.website-files.com/602cf98191f0281f4b6d6db3/602d079c71c9d0b8923420d7_Group%203.svg"
                loading="lazy"
                alt=""
                className="versus-logo"
              />
            </Link>
          </div>

          <div className="margin-top-40 margin-bottom-40">
            <div className="w-form">
              <form onSubmit={handleSubmit}>
                <h1 className="text-color-4 text-align-center">
                  Enter your code
                </h1>
                <p className="text-color-2 text-align-center">
                  We sent a code to {phoneNumber}
                </p>

                <input
                  type="text"
                  className="form-input light w-input"
                  maxLength="6"
                  placeholder="Enter OTP"
                  required
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />

                <button
                  type="submit"
                  style={{ marginTop: "5px" }}
                  disabled={otp.length < 4 || loading}
                  className="button-secondary width-full w-button"
                >
                  {loading ? <Loader /> : <span>Verify Code</span>}
                </button>

                <div className="flex-justify-center margin-top-10">
                  <p className="text-color-2 margin-bottom-0 margin-right-1">
                    Didn't get a code?
                  </p>
                  <Link
                    to="/onboarding/phone-number"
                    style={{ color: "white" }}
                  >
                    Try again
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InputCode;
